export function readStorage(key: string): unknown {
  try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch { return null; }
}
export function writeStorage(key: string, value: unknown) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* Storage is optional. */ }
}
export function removeStorage(key: string) {
  try { localStorage.removeItem(key); } catch { /* Storage is optional. */ }
}
